import { urlsWrapper } from 'config';
import {
  createCommonListConstants,
  createCommonListReducer,
  saveData,
  RESET_TYPES,
} from './utils';
import { commonGet, commonPost, commonPut } from './api';

const fieldTrialsConstants = createCommonListConstants('FIELD_TRIALS_LIST');

export default createCommonListReducer(fieldTrialsConstants);

export function fetchFieldTrials(fieldId) {
  return saveData(
    `${urlsWrapper('fields')}/${fieldId}/trials`,
    fieldTrialsConstants.SET_LIST,
    fieldTrialsConstants.SET_IS_PENDING,
    RESET_TYPES.LIST
  );
}

export function getFieldTrials(fieldId) {
  return commonGet({
    url: `${urlsWrapper('fields')}/${fieldId}/trials`,
  });
}

export function createFieldTrial(fieldId, data) {
  return commonPost({
    url: `${urlsWrapper('fields')}/${fieldId}/trials`,
    data,
  });
}

export function putFieldTrial(fieldId, trialId, data) {
  return commonPut({
    url: `${urlsWrapper('fields')}/${fieldId}/trials/${trialId}`,
    data,
  });
}

export const getFieldTrialsSelector = (state) => state.fieldTrials;
